import { ref, computed, watch } from '@vue/composition-api'

export default function useExpenseFilters(expenses) {
  const filters = ref({
    primary: null,
    secondary: null,
    tertiary: null,
    quaternary: null,
  })

  // フィルターの連動を管理
  watch(() => filters.value.primary, newVal => {
    if (!newVal) {
      filters.value.secondary = null
      filters.value.tertiary = null
      filters.value.quaternary = null
    }
  })

  watch(() => filters.value.secondary, newVal => {
    if (!newVal) {
      filters.value.tertiary = null
      filters.value.quaternary = null
    }
  })

  watch(() => filters.value.tertiary, newVal => {
    if (!newVal) {
      filters.value.quaternary = null
    }
  })

  const uniquePrimaryLabels = computed(() => {
    const labels = new Set(expenses.value.map(exp => exp.meta?.expensePrimaryLabelName).filter(Boolean))

    return Array.from(labels)
  })

  const filteredSecondaryLabels = computed(() => {
    if (!filters.value.primary) return []
    const labels = new Set(
      expenses.value
        .filter(exp => exp.meta?.expensePrimaryLabelName === filters.value.primary)
        .map(exp => exp.meta?.expenseSecondaryLabelName)
        .filter(Boolean),
    )

    return Array.from(labels)
  })

  const filteredTertiaryLabels = computed(() => {
    if (!filters.value.secondary) return []
    const labels = new Set(
      expenses.value
        .filter(exp => exp.meta?.expensePrimaryLabelName === filters.value.primary
          && exp.meta?.expenseSecondaryLabelName === filters.value.secondary)
        .map(exp => exp.meta?.expenseTertiaryLabelName)
        .filter(Boolean),
    )

    return Array.from(labels)
  })

  const filteredQuaternaryLabels = computed(() => {
    if (!filters.value.tertiary) return []
    const labels = new Set(
      expenses.value
        .filter(exp => exp.meta?.expensePrimaryLabelName === filters.value.primary
          && exp.meta?.expenseSecondaryLabelName === filters.value.secondary
          && exp.meta?.expenseTertiaryLabelName === filters.value.tertiary)
        .map(exp => exp.meta?.expenseQuaternaryLabelName)
        .filter(Boolean),
    )

    return Array.from(labels)
  })

  const filteredItems = computed(() => {
    return expenses.value
      .filter(exp => {
        if (filters.value.primary && exp.meta?.expensePrimaryLabelName !== filters.value.primary) return false
        if (filters.value.secondary && exp.meta?.expenseSecondaryLabelName !== filters.value.secondary) return false
        if (filters.value.tertiary && exp.meta?.expenseTertiaryLabelName !== filters.value.tertiary) return false
        if (filters.value.quaternary && exp.meta?.expenseQuaternaryLabelName !== filters.value.quaternary) return false

        return true
      })
      .map(exp => {
        const attr = exp.attributes || {}
        const meta = exp.meta || {}

        return {
          id: attr.id,
          amount: attr.amount || 0,
          meta: {
            date: meta.date,
            isNonCash: meta.isNonCash || false,
            expensePrimaryLabelName: meta.expensePrimaryLabelName || null,
            expenseSecondaryLabelName: meta.expenseSecondaryLabelName || null,
            expenseTertiaryLabelName: meta.expenseTertiaryLabelName || null,
            expenseQuaternaryLabelName: meta.expenseQuaternaryLabelName || null,
          },
        }
      })
  })

  return {
    filters,
    uniquePrimaryLabels,
    filteredSecondaryLabels,
    filteredTertiaryLabels,
    filteredQuaternaryLabels,
    filteredItems,
  }
}
